import React from 'react'
import { connect } from 'react-redux';
import { v4 } from 'uuid';
import { appendStyle, getIcon } from '../../Components/Functions';
import Layout from '../../Components/Layout'
import { PERMISSIONS } from '../../Constants/main';
import { routers } from '../../Constants/routers';
import { updateMyPatientsFilters, updateRecords } from '../../Redux/MyPatients/actions';
import { SearchResultItem } from '../search/SearchEngine';

export const MyFavouriteItem = (props) => {
    return (
        <div className="column is-3">
              <div className="grid-item">
                <div className="h-avatar is-big">
                  <img className="avatar"
                    src={props?.image || require("../../assets/images/placeholder.png").default}
                    alt=""/>
                <div className="badge bg-success" style={{ width: 20, height: 20, borderRadius: 20 }} />

                </div>
                <h3 className="dark-inverted" data-filter-match>{props?.name}</h3>
                <p data-filter-match>@{props?.username}</p>
                <div className="buttons mt-3">
                  <button className="button h-button is-dark-outlined">
                    <span className="icon" dangerouslySetInnerHTML={{ __html: getIcon("user") }}></span>
                    <span>Profile</span>
                  </button>
                  <a href={routers.dashboard.messanger(props?.username)} className="button h-button is-dark-outlined">
                    <span className="icon" dangerouslySetInnerHTML={{ __html: getIcon("message-circle") }}></span>
                    <span>Chat</span>
                  </a>
                </div>
              </div>
            </div>
    )
}


const MyFavourites = (props) => {
  const DATA = props?.mypatients?.results || []
    
    const updateFilters = (e) => {
        updateMyPatients({ filters: { ...props?.mypatients?.filters, ...e } })
    }

    const updateMyPatients = (e) => {
        props.updateMyPatientsFilters({ ...props?.mypatients, ...e })
    }

    const load = () => {
        props.updateRecords({...props?.mypatients});
    }

    const gotoPage = (page) => {
		props.updateRecords({ page });
	};

    React.useEffect(() => { 
      load(); 
      appendStyle("assets/css/app.css");
		  appendStyle("assets/css/main.css");
    }, []);


    return (
        <Layout title={"My Favourites"} permissions={PERMISSIONS.patient} >
      <div className="user-grid-toolbar">
        <div className="control has-icon">
          <input className="input custom-text-filter" placeholder="Search..." data-filter-target=".column" />
          <div className="form-icon">
            <i data-feather="search" />
          </div>
        </div>
        <div className="buttons">
          <div className="field h-hidden-mobile">
            <div className="control">
              <div className="h-select">
                <div className="select-box">
                  <span>Filter</span>
                </div>
                <div className="select-icon">
                  <i data-feather="chevron-down" />
                </div>
                <div className="select-drop has-slimscroll-sm">
                  <div className="drop-inner">
                    <div className="option-row">
                      <input type="radio" name="grid_filter" />
                      <div className="option-meta">
                        <span>UI/UX Design</span>
                      </div>
                    </div>
                    <div className="option-row">
                      <input type="radio" name="grid_filter" />
                      <div className="option-meta">
                        <span>Web Development</span>
                      </div>
                    </div>
                    <div className="option-row">
                      <input type="radio" name="grid_filter" />
                      <div className="option-meta">
                        <span>Software Engineering</span>
                      </div>
                    </div>
                    <div className="option-row">
                      <input type="radio" name="grid_filter" />
                      <div className="option-meta">
                        <span>Business</span>
                      </div>
                    </div>
                    <div className="option-row">
                      <input type="radio" name="grid_filter" />
                      <div className="option-meta">
                        <span>Product Management</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
       
        </div>
      </div>
      <div className="page-content-inner ">
        <div className="user-grid user-grid-v1">
          {/*List Empty Search Placeholder */}
          {DATA?.length < 1 ? (
          <div className="page-placeholder custom-text-filter-placeholder">
            <div className="placeholder-content">
              <img className="light-image" src={require("../../assets/img/illustrations/placeholders/search-4.svg").default} alt />
              <h3>We couldn't find any matching results.</h3>
              <p className="is-larger">Too bad. Looks like we couldn't find any matching results for the
                search terms you've entered. Please try different search terms or criteria.</p>
            </div>
          </div>
          ):(
          <div className="favourites flat-list">
            <div className="columns is-multiline flat-list-inner w-100 is-flex">
            {/*Grid item*/}
            {DATA.map((e, i) => {
                return <SearchResultItem data={e} index={i} />
            })}
            
          </div>
          </div>
          )}
        </div>
      </div>


        </Layout>
    )
}


const mapStateToProps = ({ mypatients }) => {
	return { mypatients };
};

const mapDispatchToProps = (dispatch) => {
	return {
        updateMyPatientsFilters: (e) => dispatch(updateMyPatientsFilters(e)),
        updateRecords: (e) => dispatch(updateRecords(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MyFavourites);
